<script>
    import NauiSwitch from "../../naui/atoms/NauiSwitch.svelte";
    import NauiInput from "../../naui/atoms/NauiInput.svelte";

    export let data={};

</script>
<div class="">
    <div class="box-l sx-1 mb-1">
        <div class="box-r min-w-200px">
            <p>¿Cuenta con ascensor?</p>
        </div>
        <NauiSwitch bind:active={data.ascensor.active}/>
        <NauiInput label="Piso" type="number" bind:value={data.ascensor.piso} />
    </div>
    <div class="box-l sx-1 mb-1">
        <div class="box-r min-w-200px">
            <p>¿Requiere fachada?</p>
        </div>
        <NauiSwitch bind:active={data.fachada.active}/>
        <NauiInput label="Piso" type="number" bind:value={data.fachada.piso} />
        <NauiInput label="Cantidad muebles" type="number" bind:value={data.fachada.intervalo} />
    </div>
    <div class="box-l sx-1 mb-1">
        <div class="box-r min-w-200px">
            <p>¿Requiere usar escalera?</p>
        </div>
        <NauiSwitch bind:active={data.escalera.active}/>
        <NauiInput label="Piso" type="number" bind:value={data.escalera.piso} />
        <NauiInput label="Cantidad muebles" type="number" bind:value={data.escalera.intervalo} />
    </div>
</div>
